export default "__VITE_ASSET__BG9SpcKQ__"